import { Box, CircularProgress, circularProgressClasses } from "@mui/material";
import { PropTypes } from "prop-types";

import { theme } from "@/theme";

const Loader = ({ primaryColor, secondaryColor, size = 40, withoutFullHeight }) => (
    <Box
        sx={{
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            position: "relative",
            height: !withoutFullHeight ? "100vh" : "initial",
        }}
    >
        <CircularProgress
            size={size}
            sx={{ color: primaryColor || theme.palette.grey[400] }}
            thickness={4}
            value={100}
            variant="determinate"
        />
        <CircularProgress
            size={size}
            thickness={4}
            sx={{
                animationDuration: "550ms",
                color: secondaryColor || theme.palette.primary,
                position: "absolute",
                [`& .${circularProgressClasses.circle}`]: { strokeLinecap: "round" },
            }}
            disableShrink
        />
    </Box>
);

export default Loader;

Loader.propTypes = {
    primaryColor: PropTypes.string,
    secondaryColor: PropTypes.string,
    size: PropTypes.number,
    withoutFullHeight: PropTypes.bool,
};
